// Fixed locale so number formatting (thousand separators, decimal point)
// stays consistent across staff regardless of their device's OS locale;
// the currency code alone drives the symbol and decimal-place conventions
// (e.g. UGX renders with 0 decimals, USD with 2 - Intl handles this per
// ISO 4217, so we don't hardcode it ourselves).
const LOCALE = "en-US";
const FALLBACK_CURRENCY = "USD";

export function formatCurrency(amount, currencyCode) {
  const value = Number(amount || 0);
  try {
    const formatted = new Intl.NumberFormat(LOCALE, {
      style: "currency",
      currency: currencyCode || FALLBACK_CURRENCY,
    }).format(value);
    // Glue the whole string together with non-breaking spaces so a sign
    // (for negative amounts) or currency code can never wrap onto its own
    // line separately from the digits.
    return formatted.replace(/ /g, " ");
  } catch (err) {
    // Unknown/invalid currency code - fall back to a plain number rather
    // than letting Intl throw and blank out the whole page.
    return value.toFixed(2);
  }
}
